import { render, staticRenderFns } from "./TopicTitle.vue?vue&type=template&id=30394cb2&scoped=true&"
import script from "./TopicTitle.vue?vue&type=script&lang=js&"
export * from "./TopicTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30394cb2",
  null
  
)

export default component.exports